export function passesModulo11(digits: string): boolean {
  const d = digits.split('').map(Number);
  const thirdDigit = d[2];

  if (thirdDigit === 6) {
    // Entidad pública
    const coef = [3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < 8; i++) sum += d[i] * coef[i];
    const remainder = sum % 11;
    const checkDigit = remainder === 0 ? 0 : 11 - remainder;
    return checkDigit === d[8];
  }

  if (thirdDigit === 9) {
    // Sociedad privada / jurídica
    const coef = [4, 3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < 9; i++) sum += d[i] * coef[i];
    const remainder = sum % 11;
    const checkDigit = remainder === 0 ? 0 : 11 - remainder;
    return checkDigit === d[9];
  }

  if (thirdDigit >= 0 && thirdDigit <= 5) {
    // Persona natural (cédula)
    const coef = [2, 1, 2, 1, 2, 1, 2, 1, 2];
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      let val = d[i] * coef[i];
      if (val > 9) val -= 9;
      sum += val;
    }
    const remainder = sum % 10;
    const checkDigit = remainder === 0 ? 0 : 10 - remainder;
    return checkDigit === d[9];
  }

  return false;
}

export function validateRucFormat(ruc: string): string | null {
  const digits = ruc.replace(/\D/g, '');

  if (digits.length !== 13) return 'Ingresa un RUC empresarial válido (13 dígitos terminados en 001)';
  if (!digits.endsWith('001')) return 'Ingresa un RUC empresarial válido (13 dígitos terminados en 001)';

  const thirdDigit = Number(digits[2]);
  const validThirdDigit = (thirdDigit >= 0 && thirdDigit <= 5) || thirdDigit === 6 || thirdDigit === 9;
  if (!validThirdDigit) return 'El tercer dígito del RUC no corresponde a un tipo de contribuyente válido';

  if (!passesModulo11(digits)) return 'El RUC ingresado no es válido (dígito verificador incorrecto)';

  return null;
}
